import type { FC } from "react";

import { UserLogSearchForm } from "src/app/features/UserLog/components/forms/UserLogSearchForm";
import { UserLogsTable } from "src/app/features/UserLog/components/tables/UserLogsTable";
import type { UserLogEntity } from "src/app/features/UserLog/types/UserLogEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const UserLogsPage: FC<NoneOwnProps> = () => {
    const table = <UserLogsTable />;
    const searchForm = <UserLogSearchForm />;
    const hasAccess = canAccess(ResourceName.USER_LOGS, "canRead");

    return (
        <PageLayout name="userLogs_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.userLogs" />
                    <ResourceManager<UserLogEntity>
                        useDataGroup
                        dataMapperKey="userLogsTableData"
                        resource={ResourceName.USER_LOGS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
